import { Card, Col, Divider, Row, Typography } from "antd";
import React, { useState } from "react";
import TPVForm from "./TPVForm";
import TPVList from "./TPVList";
import "./TPVStyles.css";

const { Title } = Typography;

const TPVManagement = () => {
	const [refreshKey, setRefreshKey] = useState(0);
	const [selectedTPV, setSelectedTPV] = useState(null);
	const isMobile = window.innerWidth < 768;

	// Esta función se ejecutará cuando se agregue un nuevo TPV
	const handleTPVAdded = () => {
		// Incrementar el key para forzar la actualización de la lista de TPVs
		setRefreshKey((prevKey) => prevKey + 1);
	};

	// Esta función se ejecutará cuando se edite un TPV
	const handleTPVEdited = (tpv) => {
		setSelectedTPV(tpv);
	};

	// Esta función se ejecutará cuando se actualice un TPV
	const handleTPVUpdated = () => {
		// Limpiar el TPV seleccionado e incrementar el key para actualizar la lista
		setSelectedTPV(null);
		setRefreshKey((prevKey) => prevKey + 1);
	};

	return (
		<div className="tpv-management-container">
			<Title level={2}>{isMobile ? "Tiendas" : "Gestión de Tiendas"}</Title>
			<Divider />

			<Row gutter={[24, 24]}>
				<Col xs={24} lg={12}>
					<Card>
						<TPVForm
							onTPVAdded={handleTPVAdded}
							onTPVUpdated={handleTPVUpdated}
							tpvToEdit={selectedTPV}
						/>
					</Card>
				</Col>

				<Col xs={24} lg={12}>
					<TPVList refreshTrigger={refreshKey} onEditTPV={handleTPVEdited} />
				</Col>
			</Row>
		</div>
	);
};

export default TPVManagement;
